import { timeFrameMapping } from './widget-constants';

export const ccWidgets = [
  {
    name: 'Device Status',
    w: 3,
    endpoint: '/s1/threats/summary',
    component: 'horizontalStatus',
    preview: 'horizontalStatusPreview',
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/protect/devices?infected=Infected',
      '/protect/devices?online=offline',
      '/protect/devices?commissioned=decommissioned',
      '/protect/devices?userActionsNeeded=reboot_category,missing_permissions_category,unprotected_category,agent_suppressed_category,incompatible_os_category',
    ],
  },
  {
    name: 'Threat Status',
    w: 3,
    endpoint: '/s1/threats/summary',
    component: 'horizontalStatus',
    disableTimeFrameDropdown: true,
    preview: 'horizontalStatusPreview',
    threatType: 'UNRESOLVED THREATS',
    drillDownUrl: [
      '/threats?status=not_mitigated&resolution=unresolved',
      '/threats?status=mitigated&resolution=unresolved',
      '/threats?status=marked_as_benign&resolution=unresolved',
      '/threats?status=not_mitigated&confidenceLevels=suspicious&resolution=unresolved',
    ],
  },
  {
    w: 3,
    name: 'Application Status',
    endpoint: '/s1/applications/count',
    component: 'horizontalStatus',
    preview: 'horizontalStatusPreview',
    disableTimeFrameDropdown: true,
    drillDownUrl: [
      '/applications?riskLevel=critical',
      '/applications?riskLevel=high',
      '/applications?riskLevel=medium',
      '/applications?riskLevel=low',
    ],
  },
  {
    w: 6,
    name: 'Top Threat Classification',
    refreshRate: 60,
    dataGroup: 'capture client',
    endpoint: '/s1/threats/filters-count',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: false,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    drillDownUrl: '/threats?classification=',
    attachDrillDownParams: true,
  },
  {
    name: 'Top Blocked Web Activity',
    w: 3,
    endpoint: '/dashboard/stats',
    component: 'horizontalBarChart',
    preview: 'horizontalBarChartPreview',
    groupByOptions: ['users', 'categories', 'domains'],
    groupBy: 'users',
    drillDownUrl: '/web-activity',
    disableTimeFrameDropdown: true,
  },
  {
    w: 3,
    name: 'Threats by Incident Status',
    endpoint: '/s1/threats/groups',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: false,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    drillDownUrl: [
      '/threats?resolution=resolved',
      '/threats?resolution=unresolved',
      '/threats?resolution=in_progress',
    ],
  },
  {
    w: 3,
    name: 'Threats by Mitigation Status',
    endpoint: '/s1/threats/groups',
    component: 'donutChart',
    preview: 'donutChartPreview',
    disableTimeFrameDropdown: false,
    timeFrameOptions: [
      timeFrameMapping.last24Hours,
      timeFrameMapping.last7Days,
      timeFrameMapping.last30Days,
    ],
    drillDownUrl: [
      '/threats?status=mitigated',
      '/threats?status=not_mitigated',
      '/threats?status=marked_as_benign',
    ],
  },

  {
    w: 3,
    name: 'Applications by Risk Level',
    endpoint: '/s1/applications/count',
    component: 'donutChart',
    preview: 'donutChartPreview',
    drillDownUrl: [
      '/applications?riskLevel=critical',
      '/applications?riskLevel=high',
      '/applications?riskLevel=medium',
      '/applications?riskLevel=low',
      '/applications?riskLevel=none',
    ],
    disableTimeFrameDropdown: true,
  },
  {
    w: 3,
    name: 'Application Vulnerabilities by OS',
    endpoint: '/s1/applications/count',
    component: 'donutChart',
    preview: 'donutChartPreview',
    drillDownUrl: [
      '/applications',
      '/applications',
      '/applications',
    ],
    disableTimeFrameDropdown: true,
  },
  {
    w: 3,
    name: 'Device by OS',
    endpoint: '/endpoints/clientCount',
    component: 'donutChart',
    preview: 'donutChartPreview',
    drillDownUrl: [
      '/protect/devices',
      '/protect/devices',
      '/protect/devices',
      '/protect/devices',
    ],
    disableTimeFrameDropdown: true,
  },
  {
    name: 'Top Users By Blocked Devices',
    w: 3,
    endpoint: '/dashboard/stats',
    component: 'horizontalBarChart',
    preview: 'horizontalBarChartPreview',
    isPercentage: true,
    drillDownUrl: '/protect/people',
    disableTimeFrameDropdown: true,
  },
];
